// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes show_section {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
  
@keyframes animation_loading_dots {
  0%   {
    transform: translateY(0)  scale(1);
  }
  4%   {
    transform: translateY(22%) scale(1.2);
  }
  25% {
    transform: translateY(-100%) scale(1.4);
  }
  50%  {
    transform: translateY(0)  scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LoadingDots/style.css"],"names":[],"mappings":"AAAA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,uCAAuC;EACzC;EACA;IACE,kCAAkC;EACpC;AACF","sourcesContent":["@keyframes show_section {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n  \n@keyframes animation_loading_dots {\n  0%   {\n    transform: translateY(0)  scale(1);\n  }\n  4%   {\n    transform: translateY(22%) scale(1.2);\n  }\n  25% {\n    transform: translateY(-100%) scale(1.4);\n  }\n  50%  {\n    transform: translateY(0)  scale(1);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
